<template>
  <div class="list">
    <div class="header">
      <div class="l" />
      <div class="r">
        <el-select
          v-model="certSearchType"
          class="input-select"
          placeholder="请选择状态"
          filterable
          clearable
          @change="clearSearchValue"
        >
          <el-option
            v-for="item in certSearchList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
        <el-input
          v-model="searchForm[certSearchType]"
          :placeholder="placeholder[certSearchType]"
          @keyup.enter.native="getList()"
        >
          <el-button
            slot="append"
            type="primary"
            @click="getList()"
          >
            搜索
          </el-button>
        </el-input>
        <el-button
          type="primary"
          @click="openBatchCertDialog"
        >
          批量上传
        </el-button>
        <el-button
          type="primary"
          @click="openCertDialog"
        >
          新增证书
        </el-button>
      </div>
    </div>
    <data-table
      :data="tabelData"
      :table-column="tableColumn"
      :pagination="true"
      @changeBypagination="tableHandle"
      @buttonClick="buttonClick"
    />
    <certDialog
      :dialog-visible.sync="certVisible"
      @confirm="getList()"
    />
    <importCertDialog
      :dialog-visible.sync="certBatchVisible"
      :course-list="courseOfflineList"
      @confirm="getList()"
    />
  </div>
</template>

<script>
import axClient from '@/services';
import dataTable from '@/components/common/dataTable.vue';
import { certSearchList, courseTypeList } from '@/config';
import certDialog from '@/components/common/certDialog.vue';
import importCertDialog from '@/components/common/importCertDialog.vue';

export default {
  name: 'Home',
  components: {
    dataTable,
    certDialog,
    importCertDialog,
  },
  data() {
    return {
      cascaderProps: {
        value: 'id',
        label: 'name',
        children: 'sonList',
      },
      certVisible: false,
      certBatchVisible: false, // 批量上传的证书
      certSearchList, // 搜索字段
      tabelData: {},
      courseOfflineList: [], // 线下课程列表
      certSearchType: 'certNoLike',
      placeholder: {
        certNoLike: '请输入证书号',
        courseNameLike: '请输入课程名',
        userIdCardLike: '请输入身份证号',
        userNameLike: '请输入姓名',
      },
      searchForm: {
        pageNum: 1,
        pageSize: 10,
        certNoLike: '',
        courseNameLike: '',
        userIdCardLike: '',
        userNameLike: '',
      },
      tableColumn: [
        {
          key: 'certNo',
          label: '证书编号',
          width: 'auto',
          dataType: 'text',
        },
        {
          key: 'courseName',
          label: '课程名称',
          width: 'auto',
          dataType: 'text',
        },
        {
          key: 'wechatNickName',
          label: '学员微信昵称',
          width: 'auto',
          dataType: 'text',
        },
        {
          key: 'userName',
          label: '证书姓名',
          width: 'auto',
          dataType: 'text',
        },
        {
          key: 'certType',
          label: '证书类型',
          width: 'auto',
          dataType: 'function',
          renderProps: '',
          render: (key) => courseTypeList.filter((item) => item.value === key),
        },
        {
          key: 'userIdCard',
          label: '身份证号',
          width: 'auto',
          dataType: 'text',
        },
        {
          key: 'certDate',
          label: '发证日期',
          width: 'auto',
          dataType: 'text',
        },
        {
          key: 'createTime',
          label: '创建时间',
          width: 'auto',
          dataType: 'time',
        },
        {
          key: 'control',
          label: '操作',
          width: '120px',
          dataType: 'component',
          renderProps: [
            {
              text: '查看', renderKey: null, type: 'info', eventIndex: 0, disableKey: null,
            },
            {
              text: '删除', renderKey: null, type: 'danger', eventIndex: 1, disableKey: null,
            },
          ],
          render: () => 'buttons',
        },
      ],
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    // 切换下拉 清除选项的值
    clearSearchValue() {
      this.searchForm.certNoLike = '';
      this.searchForm.courseNameLike = '';
      this.searchForm.userIdCardLike = '';
      this.searchForm.userNameLike = '';
    },
    // 获取列表
    async getList(num = 1) {
      this.searchForm.pageNum = num;
      const result = await axClient.cert.getList(this.searchForm);
      const offlineCourse = await axClient.cert.offlineCourse({
        pageSize: 0,
        pageNum: 0,
      });
      this.courseOfflineList = offlineCourse.list;

      const { pageNum, pageSize, total } = result;
      this.tabelData = {
        pageNum,
        pageSize,
        total,
        list: result.list,
      };
    },
    // 跳转到详情
    goDetails(item) {
      this.$router.push({ name: 'CertDetails', params: { certId: item.id } });
    },
    // table 传递过来的按钮点击
    buttonClick(type, item) {
      switch (type) {
        case 0:
          this.goDetails(item);
          break;
        case 1:
          this.deleteAccount(item);
          break;
        default:
          break;
      }
    },
    // table 改变 pagination 时间
    tableHandle(pageNum, pageSize) {
      this.searchForm.pageNum = pageNum;
      this.searchForm.pageSize = pageSize;
      this.getList(pageNum);
    },
    // 打开修改证书窗口
    openCertDialog() {
      this.certVisible = true;
    },
    // 删除证书
    deleteAccount(item) {
      this.$confirm('确定删除该证书？', '删除证书', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        showClose: false,
        type: 'error',
      }).then(async () => {
        const { id } = item;
        const data = await axClient.cert.deleteCourseCert(
          {
            id,
          },
        );
        if (data) {
          this.$message.success('删除成功');
          this.getList();
        }
      });
    },
    // 打开批量上传证书弹窗
    openBatchCertDialog() {
      this.certBatchVisible = true;
    },
  },
};
</script>
<style lang="scss" scoped>
</style>
